import { useEffect, useState } from "react";
import { getCookie } from "cookies-next";
import { setRevalidateHeaders } from "next/dist/server/send-payload";


export function useRefCode() {
  const [refCode, setRefCode] = useState('');
  const value = getCookie('ref_code') as string
  useEffect(() => {
    setRefCode(value || '')
  }, [setRefCode, value])
  return refCode
}